import { Record } from 'immutable';
import { Interval } from 'domain/Interval';
import StudentGeneralInfo from 'domain/StudentGeneralInfo';

const ACHRecord = Record({
  produced: 0,
  present: 0,
});

export class ACH extends ACHRecord { }

const MemberRecord = Record({
  studentGeneralInfo: new StudentGeneralInfo(),
  period: new Interval(),
  ach: new ACH(),
  status: undefined,
  isInProduction: undefined,
  groupId: undefined,
  skill: undefined,
});

class Member extends MemberRecord { }

export default Member;



// WEBPACK FOOTER //
// ./data/GroupMembers/model/model.js